import { Easing } from 'framer-motion';

export type ThemeType = 'dark' | 'light';

export type MultiLangText = { [lang: string]: string };

export interface MediaType {
    blob?: Blob;
    etag?: string;
    url: string;
    original_url?: string;
    resource_type: 'image' | 'video' | 'm3u8-video';
    fit?: 'fit' | 'cover';
    force_duration?: string | number | 'full';
    duration?: number;
    width?: number;
    height?: number;
    format?: string;
    dontTransform?: boolean;
    destination_url?: string;
    toDim?: boolean;
}

export type CoverType = 'fill' | 'fit';

export const SECOND = 1_000;

export const DEFAULT_EASE: Easing = [0.4, 0, 0, 1];

export function secToMs(seconds: number) {
    return seconds * SECOND;
}

export function setAnimationTimeout(fn: Function, timeOut: number) {
    let request: number;
    let start: number;

    const step = (timeStamp: number) => {
        start = start || timeStamp;
        const ellapsed = timeStamp - start;

        if (ellapsed < timeOut) {
            request = window.requestAnimationFrame(step);
        } else {
            request = undefined;
            fn();
        }
    };

    request = window.requestAnimationFrame(step);

    return () => {
        if (!request) {
            return;
        }

        window.cancelAnimationFrame(request);
        request = undefined;
    }
}

export function getLangText(multiLangText: MultiLangText, lang: string) {
    return multiLangText[lang] || '';
}

export function hasTextToDisplay(multiLangText: MultiLangText, languages?: string[]) {
    return Boolean(languages?.find(lang => getLangText(multiLangText, lang).length > 0));
}

export function getMediaDuration(media: MediaType) {
    const {
        resource_type,
        force_duration,
        duration,
    } = media;
    const toShowFullVideo = resource_type === 'video' && force_duration === 'full';

    return toShowFullVideo ? duration : Number(force_duration || 0);
}

export function scaleText(container: HTMLElement, partSelector: string) {
    const {width} = container.getBoundingClientRect();
    let maxNeededWidth = width;

    const parts = container.querySelectorAll<HTMLSpanElement>(partSelector);
    for (const part of parts) {
        const wordWidth = part.getBoundingClientRect().width;
        maxNeededWidth = Math.max(maxNeededWidth, wordWidth);
    }

    const scale = width / maxNeededWidth;

    const style = window.getComputedStyle(container);
    container.style.fontSize = `calc(${style.fontSize} * ${scale})`;
    container.style.lineHeight = `calc(${style.lineHeight} * ${scale})`;

    return scale;
}

export function random(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
